"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var ng2_bs3_modal_1 = require("@bhtp-fork/ng2-bs3-modal/ng2-bs3-modal");
var modal_service_1 = require("./modal.service");
var CustomersModalComponent = (function () {
    function CustomersModalComponent(modalService) {
        this.modalService = modalService;
        this.customerSelected = new core_1.EventEmitter(false);
    }
    CustomersModalComponent.prototype.ngOnInit = function () {
        this.onCloseModal(null);
        this.modalService.registerCustomersModalComponent(this);
    };
    CustomersModalComponent.prototype.ngOnDestroy = function () {
        this.onCloseModal(null);
        this.modalService.clearCustomersModalComponent();
    };
    CustomersModalComponent.prototype.customerDisplayString = function (customer) {
        var customerString = '';
        customerString += customer.firstName ? customer.firstName + ' ' : '';
        customerString += customer.lastName ? customer.lastName + ' ' : '';
        customerString += customer.email ? '- ' + customer.email : '';
        return customerString;
    };
    CustomersModalComponent.prototype.open = function (customers) {
        this.clearModalData();
        this.customers = customers;
        this.noCustomersText = this.customers.length > 0 ? null : 'No customers found for search text.';
        this.title = 'Choose a Customer';
        this.cancelButtonText = 'Cancel';
        if (!this.modal.visible) {
            this.modal.open();
        }
        return this.modal.onClose.asObservable();
    };
    CustomersModalComponent.prototype.onCloseModal = function (customer) {
        if (this.modal && customer) {
            this.customerSelected.emit(customer);
            this.modal.close(null);
        }
        else {
            this.modal.close(null);
        }
    };
    CustomersModalComponent.prototype.clearModalData = function () {
        // there is a single instance of this component,
        // so clear data for the next use
        this.title = null;
        this.messages = [];
        this.cancelButtonText = null;
    };
    return CustomersModalComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CustomersModalComponent.prototype, "agentCode", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CustomersModalComponent.prototype, "customerSelected", void 0);
__decorate([
    core_1.ViewChild('customerModal'),
    __metadata("design:type", ng2_bs3_modal_1.ModalComponent)
], CustomersModalComponent.prototype, "modal", void 0);
CustomersModalComponent = __decorate([
    core_1.Component({
        selector: 'customers-modal',
        template: "<modal #customerModal class=\"panel-primary\">     <div class=\"modal-heading\" style=\"border-top-left-radius: 4px; border-top-right-radius: 4px;\">         <modal-header [show-close]=\"true\">             <h4 class=\"modal-title\">{{title}}</h4>         </modal-header>     </div>     <modal-body>         <div *ngIf=\"noCustomersText\">             {{noCustomersText}}         </div>         <div class=\"panel panel-default panel-heading\" *ngFor=\"let customer of customers\" (click)=\"onCloseModal(customer)\">             {{ customerDisplayString(customer) }}         </div>     </modal-body>     <modal-footer>         <button type=\"button\" *ngIf=\"cancelButtonText\" class=\"btn btn-default btn-cust\" (click)=\"onCloseModal()\">             {{ cancelButtonText }}         </button>     </modal-footer> </modal>"
    }),
    __metadata("design:paramtypes", [modal_service_1.ModalService])
], CustomersModalComponent);
exports.CustomersModalComponent = CustomersModalComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/modals/customers-modal.component.js